

export enum DateType {
	DateOfEvent = 1,
	DateFieldValue = 2
}